export default "__VITE_ASSET__Dv8gLxF9__"